import socket, { invokeRPC } from './socket.js'

export function getSimpleIframe(projectId) {
  return invokeRPC('iframe', 'getSimpleIframe', { project_id: projectId })
}

export function updateSimpleIframe(data) {
  return invokeRPC('iframe', 'updateSimpleIframe', data)
}
